import SecureRequest from "utils/securerequest";

export interface DocumentRulePayload {
  clinical_document_type: "initial_treatment_plan" | "reassessment_treatment_plan";
  required_assessments?: { operator: "AND" | "OR"; assessment_types: string[] } | null;
  requires_referring_provider?: boolean;
  requires_criminal_legal_history?: boolean;
  requires_drug_alcohol_use?: boolean;
  requires_trauma_history?: boolean;
}

export async function createDocumentRule(planId: number, payload: DocumentRulePayload) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.post(`/v3/insurance-plans/${planId}/document-rules`, payload);
}

export async function updateDocumentRule(
  planId: number,
  ruleId: number,
  payload: Partial<DocumentRulePayload>
) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.patch(`/v3/insurance-plans/${planId}/document-rules/${ruleId}`, payload);
}

export async function deleteDocumentRule(planId: number, ruleId: number) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.delete(`/v3/insurance-plans/${planId}/document-rules/${ruleId}`);
}
